/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for DocumentResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetDocumentsResponse, GetDocumentByIdResponse } from "../models";

@Injectable({ providedIn: "root" })
export class DocumentResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getDocuments(folderId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetDocumentsResponse, unknown> & { defaultValue: NoInfer<GetDocumentsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDocumentsResponse>;
    getDocuments(folderId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetDocumentsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDocumentsResponse | undefined>;
    getDocuments(folderId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetDocumentsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDocumentsResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const folderIdValue = typeof folderId === 'function' ? folderId() : folderId;
            if (folderIdValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, folderIdValue, 'folderId');
            }
            return {
                url: `${this.basePath}/Document`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getDocumentById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetDocumentByIdResponse, unknown> & { defaultValue: NoInfer<GetDocumentByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDocumentByIdResponse>;
    getDocumentById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetDocumentByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDocumentByIdResponse | undefined>;
    getDocumentById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetDocumentByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetDocumentByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Document/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    downloadDocument(id: Signal<number> | number, resourceOptions: HttpResourceOptions<Blob, Blob> & { defaultValue: NoInfer<Blob> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob>;
    downloadDocument(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined>;
    downloadDocument(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined> {
        return httpResource.blob(() => {
            return {
                url: `${this.basePath}/Document/${typeof id === 'function' ? id() : id}/download`,
                method: "GET",
                responseType: 'blob' as 'blob',
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
